module.exports = __webpack_public_path__ + "media/images/countrysquared/ua-c37f8d0232f9dc108758fa678fea9923.svg";